
export const PM_SITIES= "PM_SITIES";
export const PM_CHECKLIST_QUES= "PM_CHECKLIST_QUES";
export const GET_MONTHS = "GET_MONTHS";
export const DOWNLOAD_PM_LIST = "DOWNLOAD_PM_LIST";
export const VIEW_PM_REPORT = "VIEW_PM_REPORT";
export const PM_SITIES_FILTER = "PM_SITIES_FILTER";
export const PM_SOFTWARE_AMSWER = "PM_SOFTWARE_AMSWER";
export const PM_SOFTWARE_MAINTENANCE_SITES = "PM_SOFTWARE_MAINTENANCE_SITES";
export const PM_SOFTWARE_UPDATE_SITE_ASSIGNEE = "PM_SOFTWARE_UPDATE_SITE_ASSIGNEE";
export const PM_SOFTWARE_VIEW_REPORT = "PM_SOFTWARE_VIEW_REPORT";
export const PM_SOFTWARE_REPORT_APPROVED = "PM_SOFTWARE_REPORT_APPROVED";
export const PM_SOFTWARE_REPORT_REJECTED = "PM_SOFTWARE_REPORT_REJECTED";
export const PM_SOFTWARE_POST_MAIL = "PM_SOFTWARE_POST_MAIL";
export const PM_SOFTWARE_PM_LIST_DOWNLOAD = "PM_SOFTWARE_PM_LIST_DOWNLOAD";
export const PM_SOFTWARE_PM_FILTER = "PM_SOFTWARE_PM_FILTER";


